export const defaultFaqs = [
  {
    question: "How much do long-distance movers in Canada cost?",
    answer:
      "The cost depends on factors such as distance, shipment size, timing, and additional services. Go Move Canada provides transparent estimates and affordable long-distance moving services tailored to your relocation needs.",
  },
  {
    question: "Do you provide cross-country moving services?",
    answer:
      "Yes. We specialize in nationwide relocations and are proud to serve customers looking for reliable cross-country movers in Canada.",
  },
  {
    question: "Are you an affordable long-distance moving company?",
    answer:
      "We focus on delivering competitive pricing and exceptional value. Customers looking for low-cost long-distance moving companies, inexpensive long-distance moving companies, or affordable long-distance movers can request a free personalized quote.",
  },
  {
    question: "Do you offer packing and storage?",
    answer:
      "Yes. We provide optional packing, unpacking, and storage services to make your move more convenient.",
  },
  {
    question: "How early should I book?",
    answer:
      "Booking four to six weeks in advance is recommended, especially during peak moving seasons, although we also assist with many last-minute moves.",
  },
];

const cityFaqRoutes = {
  "/movers-in-calgary": "Calgary",
  "/movers-in-ottawa": "Ottawa",
  "/movers-in-alberta": "Alberta",
  "/mover-in-edmonton": "Edmonton",
};

const buildCityFaqs = (city) => [
  {
    question: `How much do movers in ${city} cost?`,
    answer: `Moving costs in ${city} depend on distance, shipment size, timing, access, and any packing or storage needs. Go Move Canada provides transparent estimates tailored to your relocation.`,
  },
  {
    question: `Do you provide long-distance moving services in ${city}?`,
    answer: `Yes. Go Move Canada supports long-distance moves from ${city} to other cities and provinces across Canada with careful planning, professional crews, and dependable transportation.`,
  },
  {
    question: `Are you an affordable moving company in ${city}?`,
    answer: `Yes. We focus on competitive pricing, dependable service, and clear estimates for customers comparing affordable movers in ${city}.`,
  },
  {
    question: `Do your ${city} movers offer packing and storage?`,
    answer: `Yes. Optional packing, unpacking, and storage support is available to make your ${city} move more convenient and organized.`,
  },
  {
    question: `How early should I book movers in ${city}?`,
    answer: `Booking four to six weeks ahead is recommended, especially during busy moving seasons. We can also help with many last-minute moving requests when availability allows.`,
  },
];

export const getFaqsForPath = (path) => {
  const city = cityFaqRoutes[path];
  return city ? buildCityFaqs(city) : defaultFaqs;
};
